import {
  DJ_GETLISTADO_START,
  DJ_APROBARRECHAZAR_START,
} from "../../const/actionTypes";

export const GetDiasJefe = (payload) => ({
  type: DJ_GETLISTADO_START,
  payload,
});
export const AprobarRechazar = (payload) => ({
  type: DJ_APROBARRECHAZAR_START,
  payload,
});
